import { createContext } from 'react';

import { DetailedPlaybackOption, Title } from '@models/Title';

export type MasterIdManagerContextValues = {
  handleSplitIntoNewTitle: (title: Title, playbackOption: DetailedPlaybackOption) => void;
  openMergeTitlesView: (title: Title) => void;
  openMovePlaybackOptionView: (title: Title, playbackOption: DetailedPlaybackOption) => void;
};

const MasterIdManagerContext = createContext<MasterIdManagerContextValues>({
  handleSplitIntoNewTitle: () => void 0,
  openMergeTitlesView: () => void 0,
  openMovePlaybackOptionView: () => void 0,
});

export default MasterIdManagerContext;
